<template>
</template>

<script>
	import { wclient } from '../../static/wclient-mobile.js'
	export default {
		name: 'Loading',
		data() {
			return {
				baseUrl: ""
			}
		},
		methods: {
			ToMy() {
				var that = this;
				sessionStorage.setItem('to','my')
				sessionStorage.removeItem('landType')
				that.$router.push({
					name: 'Loading'
				});
			}
		},
		mounted() {
			var that = this;
			that.ToMy()
		}
	}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/ToMy.vue